/**
 * Qualitication de paramètre
 */
export enum QualificationParametre {
    'INFORME',
    'ESTIME',
    'REGLEMENTAIRE',
    'CALCULE',
    'PROPAGE',
    'MESURE',
    'DOCUMENTE'
}
